import React from 'react';
import "./index.css";
import { FaAngleRight } from "react-icons/fa";

const exp = () => {
  return (
    <>
      <section className='exp-sec' id='exp'>
        <div className='exp-head'>
          <span>02.</span> Experience
        </div>

        {/* exp body */}
        <div className='exp-div'>
          <div className='job'>
            <span className='job-head'>Freelancer - MERN Stack </span>
            <p className='duration'>Aug 2022 - Present</p>
            <div className='job-desc'>
            <ul>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Projects-
                      <a rel='noreferrer' href='http://www.ashihelmet.com/' target='_blank'>  Ashi Helmets </a>|
                      <a rel='noreferrer' href='http://www.nanadairyfarming.com/' target='_blank'>  Nana Dairy Farming </a>|
                      <a rel='noreferrer' href='http://www.tenantnetwork.in/' target='_blank'>  Tenant Network </a>
                  </p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Worked on MERN full stack website development.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>In a collaboration with the freelancing team.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Experienced in development and deployment.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Skills used- MYSQL, EXPRESS, REACT, NODE, GIT</p>
                </li>
              </ul>
            </div>
          </div>
          <div className='job'>
            <span className='job-head'>Node Js Intern <span className='company'><a rel='noreferrer' href='https://jungleworks.com/' target='_blank'>@Jungleworks Pvt. Ltd. </a></span> </span>
            <p className='duration'>Jan 2022 - Aug 2022</p>
            <div className='job-desc'>
            <ul>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                <p>worked on Node.js as an Associate Backend Developer.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                <p>Handled all monthly sprints for Live project - <a rel='noreferrer' href='https://webapp.rappocart.com/en/' target="_blank">Rappo</a> and others.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                  <p>Had experience with client issues, bug fixing, Debugging, Unit Testing, building API, server handling and adding new features.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                <p>Gone through the clients call for task discussion.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                <p>Also worked on email triggering, CSV handling, MySQL Open API's etc.</p>
                </li>
                <li><span className='skills-icon'><FaAngleRight/></span> 
                <p>Also worked on multiple projects when required.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default exp